export default {
  title: '部门协作',
  icon: 'group',
  hideSub: true,
  path: '/group/task',
  children: (pre => [
    { path: `${pre}task`, title: '任务下发', icon: 'dot-circle-o' },
    { path: `${pre}my-task`, title: '任务接收', icon: 'dot-circle-o' },
    { path: `${pre}share`, title: '内容共享', icon: 'dot-circle-o' },
    { path: `${pre}setting`, title: '部门配置', icon: 'wrench' },
  ])('/group/')
}
